<div class="sidebar included" *ngIf="carbonOffsets">
	<app-sidebar-header [title]="( 'extrasSidebar.carbonOffset.title.addressYourCarbonFootprint' | ibeadmin | async )" [label]=""></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div *ngIf="!isLoading">
			<div #sidebar__info class="sidebar__info" id="vantages_section">
				<ul class="vantages-listing">
					<li>{{ 'extrasSidebar.carbonOffset.text.estimatedCarbonEmissions' | ibeadmin | async }} <b>{{ carbonOffsets.co2Emissions | indraFormatNumberToLocale }}</b></li>
					<li>{{ 'extrasSidebar.carbonOffset.text.helpAddressEmissions' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.carbonOffset.text.supportProjectsReduceCarbon' | ibeadmin | async }}</li>
				</ul>
			<p>{{ 'extrasSidebar.carbonOffset.text.learnMoreSustainability' | ibeadmin | async }}</p>
			</div>

			<div class="sidebar-flight-text" id="add_section">
				{{ 'extrasSidebar.carbonOffset.text.contriForAllPassenger' | ibeadmin | async }}<b>{{ carbonOffsets.totalForAllPassenger + currency | indracurrency }}</b>
				<button *ngIf="!carbonOffset" class="button" (click)="INDRA_carbonOffsetChanged()"
					[attr.aria-label]="'extrasSidebar.carbonOffset.aria.addCarbonOffset' | ibeadmin | async">
					{{ 'extrasSidebar.carbonOffset.text.add' | ibeadmin | async }}
				</button>
			</div>

			<div class="sidebar__info" id="conditions_section">
				<h4 class="title-h4">{{ 'extrasSidebar.carbonOffset.text.conditions' | ibeadmin | async }}</h4>
				<ul class="vantages-listing">
					<li>{{ 'extrasSidebar.carbonOffset.text.voluntary' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.carbonOffset.text.nonRefundable' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.carbonOffset.text.tapDoesNotProfit' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.carbonOffset.text.deliveredByChooose' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.carbonOffset.text.acknowledgeChoooseTermsAndConditions' | ibeadmin | async }}</li>
				</ul>
			</div>

			<div class="sidebar-flight-text" id="terms_section">
				<a class="link" target=”_blank” href="{{ 'externalURLs.choooseTermsAndConditions' | ibeadmincfg }}" [attr.aria-label]="'extrasSidebar.carbonOffset.aria.choooseTermsAndConditions' | ibeadmin | async">
					{{ 'extrasSidebar.carbonOffset.text.choooseTermsAndConditions' | ibeadmin | async }}</a>
			</div>

			<div class="sidebar-flight-text" *ngIf="carbonOffset">
				<button class="button button-main-line" (click)="INDRA_carbonOffsetChanged()"
					[attr.aria-label]="'extrasSidebar.carbonOffset.label.removeCarbonOffset' | ibeadmin | async">
					{{ 'extrasSidebar.carbonOffset.label.removeCarbonOffset' | ibeadmin | async }}
				</button>
			</div>

			<div class="sidebar-flight-text" id="close_section">
				<a class="link extras-feature__link" [attr.aria-label]="'extrasSidebar.carbonOffset.aria.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()"
						href="javascript:;" role="button">{{ 'extrasSidebar.carbonOffset.label.closeWindow' | ibeadmin | async }}</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer ">
	</div>
</div>
